export const FETCH_LOCATIONS_SUCCESS = 'fetch_locations_success'
export const FETCH_WAREHOUSE_LOCATIONS_SUCCESS = 'fetch_warehouse_locations_success'
